export default __webpack_public_path__ + "static/when-where-fde53da64522d3776d8ac56067a76d2e.png";